{
  "sources": ["aar47-spuistraat", "painting-1538", "woodcut-1544"],
  "notes": "AAR 47 identifies four broad tree-filled yards north of Raamsteeg (pp. 7–8) but finds earlier buildings within that area (pp. 12–15). These two volumes reconcile the evidence provisionally. Depth 6 m follows two foundations; 14 m assumes the fragment is a rear wall. The excavation did not recover complete plans. Modern parcel numbers identify the excavation sites, not 1538 addresses. Widths, quay chainages, axes, two storeys, openings, gables and tile roofs are estimates. The four garden outlines are fitted to retained streets rather than transferred literally from the distorted woodcut. Eight separately recorded roof bodies now replace their generic perimeter.",
  "sourceSize": [6692, 4866],
  "gardenPicks": [
    [3153, 1331],
    [3228, 1370],
    [3268, 1399],
    [3305, 1424]
  ],
  "source": "quay-nieuwezijds-achterburgwal-2",
  "side": "right",
  "houses": [
    {
      "id": "raam-excavation-256",
      "chainage": 874.7,
      "width": 5.72,
      "depth": 14,
      "depthEvidence": "assumed rear wall, dated foundation timber 1519 ± 10 years"
    },
    {
      "id": "raam-excavation-258",
      "chainage": 880.5,
      "width": 5.72,
      "depth": 6,
      "depthEvidence": "two parallel foundations, 6 m apart; associated pottery 1475–1525"
    }
  ]
}
